import { Modal } from "@/components/elements/Modal";
import { Box, Link, Stack, Typography } from "@mui/material";
import { FCC } from "@/types/common";
import { getDynamicRoute } from "@/utils/url";
import { AppRoutes } from "@/routes/config";
import { TCaseMatches } from "@/features/talent/types/talentForm";
import { secondary, text } from "@/theme/colors";

type TTalentDeleteErrorModalProps = {
  open: boolean;
  onClose: () => void;
  caseMatches: TCaseMatches[];
};

export const TalentDeleteErrorModal: FCC<TTalentDeleteErrorModalProps> = ({ open, onClose, caseMatches }) => {
  const handleCaseClick = (caseMatch: TCaseMatches) => {
    const caseId = caseMatch.case?.id ?? caseMatch.caseId;
    const jobId = caseMatch.case?.jobId;

    if (jobId && caseId) {
      const caseEditRoute = getDynamicRoute(AppRoutes.caseEdit, {
        jobId: String(jobId),
        caseId: String(caseId),
      });

      window.open(caseEditRoute, "_blank");
    }
  };

  return (
    <Modal isOpen={open} onClose={onClose} labelClose="閉じる" width={500} enableFooter={true} hiddenOkBtn={true} justifyBtnAction={"center"}>
      <Box mb={2}>
        <Typography variant="body1" sx={{ mb: 2, mt: 1 }}>
          以下案件にマッチングしているため削除できません。
        </Typography>
        <Stack
          spacing={1.5}
          sx={{
            maxHeight: "500px",
            overflow: "auto",
          }}
        >
          {caseMatches.map((caseMatch) => {
            const caseId = caseMatch.case?.id ?? caseMatch.caseId;
            const jobId = caseMatch.case?.jobId;
            const caseName = caseMatch.case?.name;
            const canNavigate = jobId && caseId;

            return (
              <Box
                key={caseMatch.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    color: text.primary,
                    lineHeight: 1,
                    flexShrink: 0,
                  }}
                >
                  ・
                </Typography>
                {canNavigate && caseName ? (
                  <Link
                    component="button"
                    variant="body1"
                    onClick={() => handleCaseClick(caseMatch)}
                    sx={{
                      textDecoration: "none",
                      color: secondary[80],
                      cursor: "pointer",
                      textAlign: "left",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {caseName}
                  </Link>
                ) : (
                  <Typography variant="body1">{caseName || `案件ID: ${caseId}`}</Typography>
                )}
              </Box>
            );
          })}
        </Stack>
      </Box>
    </Modal>
  );
};
